var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('b-row',{attrs:{"id":"analyses"}},[_c('b-col',{staticClass:"shadow-sm"},[_c('h4',{staticClass:"card-title font-weight-bold"},[_vm._v("\n        Verwendungs-Daten als Excel exportieren\n      ")]),_c('b-card-body',[_c('b-row',[_c('AnalysesManagment',{staticClass:"w-100"})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }